<template>
  <div class="event-child">
    <div class="news-list mt-5">
      <v-row>
        <Card
          v-for="article in news"
          :key="article.ID"
          :title="article.title.rendered"
          :date="article.date"
          :image="article.thumbnail"
          :link="{ name: 'article', params: {slug: decodeURIComponent(article.slug)} }"
        ></Card>
      </v-row>
    </div>

    <Pagination v-model="page"></Pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/helpers.js'
import Pagination from '@/components/Utils/Pagination.vue'
import Card from '@/components/Card.vue'

export default {
  name: 'EventNews',
  components: { Pagination, Card },
  data() {
    return { page: 1 }
  },

  mounted () {
    this.fetchNews()
  },

  methods: {
    formatDate,

    fetchNews () {
      this.$store.commit('setNews', [])
      if (this.event.news && this.event.news.length > 0) {
        this.$store.commit('setLoading', true)

        this.$store.dispatch('getNews', { page: this.page, ids: this.event.news }).then(() => {
          this.$store.commit('setLoading', false)
        }).catch(() => {
          this.$store.commit('setLoading', false)
          this.$store.commit('showAlert', { type: 'error', message: 'Грешка при зареждането на новините.' })
        })
      }
    },
  },

  computed: mapGetters(['event', 'news', 'loading']),

  watch: {
    page: 'fetchNews'
  }
}
</script>
